// This file is auto-generated by backstage-cli translations import
// Do not edit manually.

import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { apiDocsTranslationRef } from '@backstage/plugin-api-docs/alpha';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';
import { catalogGraphTranslationRef } from '@backstage/plugin-catalog-graph/alpha';
import { catalogImportTranslationRef } from '@backstage/plugin-catalog-import/alpha';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';
import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';
import { homeTranslationRef } from '@backstage/plugin-home/alpha';
import { homeReactTranslationRef } from '@backstage/plugin-home-react/alpha';
import { kubernetesTranslationRef } from '@backstage/plugin-kubernetes/alpha';
import { orgTranslationRef } from '@backstage/plugin-org/alpha';
import { notificationsTranslationRef } from '@backstage/plugin-notifications/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react/alpha';
import { searchTranslationRef } from '@backstage/plugin-search/alpha';
import { searchReactTranslationRef } from '@backstage/plugin-search-react/alpha';
import { techdocsTranslationRef } from '@backstage/plugin-techdocs/alpha';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';

export default [
  createTranslationResource({
    ref: apiDocsTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/api-docs.de.json'),
    },
  }),
  createTranslationResource({
    ref: catalogTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/catalog.de.json'),
    },
  }),
  createTranslationResource({
    ref: catalogGraphTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/catalog-graph.de.json'),
    },
  }),
  createTranslationResource({
    ref: catalogImportTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/catalog-import.de.json'),
    },
  }),
  createTranslationResource({
    ref: catalogReactTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/catalog-react.de.json'),
    },
  }),
  createTranslationResource({
    ref: coreComponentsTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/core-components.de.json'),
    },
  }),
  createTranslationResource({
    ref: homeTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/home.de.json'),
    },
  }),
  createTranslationResource({
    ref: homeReactTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/home-react.de.json'),
    },
  }),
  createTranslationResource({
    ref: kubernetesTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/kubernetes.de.json'),
    },
  }),
  createTranslationResource({
    ref: orgTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/org.de.json'),
    },
  }),
  createTranslationResource({
    ref: notificationsTranslationRef,
    translations: {
      de: () =>
        import('./../../translations/messages/plugin.notifications.de.json'),
    },
  }),
  createTranslationResource({
    ref: scaffolderTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/scaffolder.de.json'),
    },
  }),
  createTranslationResource({
    ref: scaffolderReactTranslationRef,
    translations: {
      de: () =>
        import('./../../translations/messages/scaffolder-react.de.json'),
    },
  }),
  createTranslationResource({
    ref: searchTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/search.de.json'),
    },
  }),
  createTranslationResource({
    ref: searchReactTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/search-react.de.json'),
    },
  }),
  createTranslationResource({
    ref: techdocsTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/techdocs.de.json'),
    },
  }),
  createTranslationResource({
    ref: userSettingsTranslationRef,
    translations: {
      de: () => import('./../../translations/messages/user-settings.de.json'),
    },
  }),
];
